import { useTranslation } from '@shared/core';
import { EventPageType, EventWebsiteGuestQuery, GetRegistryDataQuery } from '@graphql/generated';
import { mockCustomPageDataFoo } from '@apps/guest/packages/layout-engine/widgets/Custom/mocks.constants';
import { useFeatureValue } from '@shared/core/featureFlags';

export const useAppPage = () => {
  const { t: appsTranslation } = useTranslation('eventSiteApps');
  const customPageMockDataEnabled = useFeatureValue('guestSiteEnableCustomPageMockData').value === 'on';

  const addAppPage = (eventHandle: string | undefined, event: EventWebsiteGuestQuery['eventByName'] | GetRegistryDataQuery['eventByName']) => {
    const newPages = event?.pages ? [...event.pages] : [];

    if (!event?.settings?.hideDownloadAppPage) {
      newPages.push({
        id: 'app',
        disabled: false,
        mobilePhoto: null,
        pageSlug: 'app',
        pageTitle: appsTranslation('title')(),
        photo: null,
        subTitle: appsTranslation('message')({ website: eventHandle }),
        type: EventPageType.app
      });
    }

    // just a test mechanism to force pushing mock custom page data onto page list
    // in actual implementation custom type will be included in eventbyname query on guestsite base load
    if (customPageMockDataEnabled) {
      const mockCustomPageData = [mockCustomPageDataFoo];
      newPages.push(...mockCustomPageData);
    }

    return newPages;
  };

  return addAppPage;
};
